<template>
  <div class="company-introduce-background">
    <div class="company-introduce-banner">
      <div class="company-introduce-container">
        <div class="company-introduce-banner-title">{{ $t("navbar.Video") }}</div>
      </div>

      <img class="company-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="company-introduce-container">
      <div class="company-introduce-content">
        <div class="company-introduce-content-info">
          <div
            class="product-markdown-content"
            v-html="markdownHtml"
            @click="onMarkdownClick"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videoTutorialMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/VideoTutorial.md'
import videoTutorialMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/VideoTutorial.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'

export default {
  name: 'VideoTutorial',
  computed: {
    markdownHtml() {
      const md = this.$i18n.locale === 'en' ? videoTutorialMdEn : videoTutorialMd
      return parseMarkdown(md)
    }
  },
  methods: {
    onMarkdownClick(event) {
      const link = event.target.closest('a[data-internal-link="true"]')
      if (!link) return
      event.preventDefault()
      const href = link.getAttribute('href') || ''
      const routeMap = {
        '/Train': 'Train',
        '/Camp': 'Camp',
        '/Seminar': 'Seminar',
      }
      const routeName = routeMap[href]
      if (routeName) {
        this.$router.push({ name: routeName })
      } else {
        this.$router.push(href)
      }
    }
  }
}
</script>

<style scoped>
.company-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.company-introduce-background {
  margin-top: 70px;
}
.company-introduce-banner {
  overflow: hidden;
}
.company-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.company-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.company-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.company-introduce-content-info {
  margin-top: 40px;
}
.product-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.product-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 36px;
}
.product-markdown-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.product-markdown-content >>> p {
  margin-bottom: 16px;
}
.product-markdown-content >>> a {
  color: rgba(73, 145, 201, 1);
  text-decoration: underline;
  cursor: pointer;
}
@media screen and (max-width: 482px) {
  .company-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .company-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .company-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .company-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .company-introduce-container {
    max-width: 1068px;
  }
}
</style>
